module.exports = __webpack_public_path__ + "img/153.8b1e7dcb.jpg";